export const createConsoleBanner = () => {
  console.log(`
   _______ _____  _______ _______
  |   |   |  |  ||   |   |   |   |
  |       |__    |       |       |
  |__|_|__|  |__||__|_|__|___|___|

    #M4MH | Move 4 Mental Health
  `);
};
